import { CloseButton } from "../../close-button";

import { feedbackTypes, type FeedbackType } from "..";

interface FeedbackTypeStepProps {
  onFeedbackTypeChanged: (type: FeedbackType) => void;
}

export function FeedbackTypeStep({
  onFeedbackTypeChanged,
}: FeedbackTypeStepProps) {
  return (
    <>
      <header className="flex items-center justify-between w-full px-2">
        <span className="text-lg font-medium text-zinc-100">Deixe seu feedback</span>

        <CloseButton />
      </header>

      <div className="flex py-8 gap-4 w-full justify-center animate-fade-in-up">
        {Object.entries(feedbackTypes).map(([key, value], index) => {
          return (
            <button
              key={key}
              type="button"
              title={`Feedback sobre: ${value.title}`}
              aria-labelledby={`Feedback sobre: ${value.title}`}
              onClick={() => onFeedbackTypeChanged(key as FeedbackType)}
              style={{ animationDelay: `${index * 100}ms` }}
              className="bg-zinc-800/50 backdrop-blur-sm rounded-2xl py-5 w-24 flex flex-1 flex-col items-center gap-3 border border-zinc-700 hover:border-brand-500 hover:bg-zinc-800 focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20 transition-all duration-300 ease-spring cursor-pointer shadow-lg hover:shadow-brand-500/10 hover:-translate-y-1 group relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-brand-500/0 to-brand-500/0 group-hover:from-brand-500/5 group-hover:to-transparent transition-colors duration-500" />
              
              <img
                className="w-10 h-10 object-contain transition-transform duration-300 group-hover:scale-110"
                src={value.image.source}
                alt={value.image.alt}
              />
              <span className="text-sm font-medium text-zinc-200 group-hover:text-white transition-colors">{value.title}</span>
            </button>
          );
        })}
      </div>
    </>
  );
}
